import { FictionType } from '../../../../../api/local-content/collection/product/types';
import { TFunction } from 'i18next';

export const mapFiction = (fiction: boolean | string | undefined, t: TFunction) => {
    const fictionData: FictionType = {
        current: t(`yourLocalContent.yourTitles.fictionDropdown.${fiction}`, {
            defaultValue: t('yourLocalContent.yourTitles.select')
        }),
        currentKey: fiction,
        all: {
            true: t('yourLocalContent.yourTitles.fictionDropdown.true'),
            false: t('yourLocalContent.yourTitles.fictionDropdown.false')
        }
    };

    return { fictionData };
};
